module.exports = __webpack_public_path__ + "img/contact.10c6f0bc.png";